import { useNavigate, useLocation } from "react-router-dom";
import { Baseball, Football, Basketball, Hockey, GraduationCap, SoccerBall } from "@phosphor-icons/react";

export const SPORTS = [
  { key: "mlb", label: "MLB", icon: Baseball, live: true, path: "/dashboard" },
  { key: "nfl", label: "NFL", icon: Football, live: true, path: "/nfl" },
  { key: "nba", label: "NBA", icon: Basketball, live: true, path: "/nba", badge: "NEW" },
  { key: "nhl", label: "NHL", icon: Hockey, live: true, path: "/nhl", badge: "NEW" },
  { key: "ncaaf", label: "NCAAF", icon: GraduationCap, live: true, path: "/ncaaf" },
  { key: "soccer", label: "Soccer", icon: SoccerBall, live: true, path: "/soccer", badge: "NEW" },
  { key: "ncaab", label: "NCAAB", icon: GraduationCap },
];

export function SportSwitcher() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = pathname.startsWith("/coming-soon/") ? pathname.split("/")[2] : pathname.startsWith("/nfl") ? "nfl" : pathname.startsWith("/ncaaf") ? "ncaaf" : pathname.startsWith("/nba") ? "nba" : pathname.startsWith("/nhl") ? "nhl" : pathname.startsWith("/soccer") ? "soccer" : "mlb";
  return (
    <div className="bg-[#070707] border-b border-white/10 px-4 md:px-6 lg:px-8 overflow-x-auto" data-testid="sport-switcher">
      <div className="flex items-center gap-1.5 py-2.5 min-w-max">
        {SPORTS.map(({ key, label, icon: Icon, live, path, badge }) => {
          const isActive = active === key;
          return (
            <button
              key={key}
              data-testid={`sport-tab-${key}`}
              onClick={() => navigate(path || `/coming-soon/${key}`)}
              className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-black uppercase tracking-wider border transition-colors duration-200 ${
                isActive
                  ? "bg-[#a855f7] text-black border-[#a855f7] shadow-[0_0_18px_rgba(168,85,247,0.35)]"
                  : "border-white/10 text-neutral-400 hover:border-[#a855f7]/50 hover:text-[#a855f7]"
              }`}
            >
              <Icon size={15} weight="duotone" />
              {label}
              {live ? (
                badge ? (
                  <span className={`text-[7px] font-black tracking-widest px-1 py-px rounded-sm ${isActive ? "bg-black/25 text-black" : "bg-[#22c55e]/15 text-[#22c55e]"}`}>
                    {badge}
                  </span>
                ) : (
                  !isActive && <span className="w-1.5 h-1.5 rounded-full bg-[#22c55e] animate-pulse" />
                )
              ) : (
                <span className={`text-[7px] font-black tracking-widest px-1 py-px rounded-sm ${isActive ? "bg-black/25 text-black" : "bg-[#a855f7]/15 text-[#a855f7]"}`}>
                  Soon
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
